module.exports = __webpack_public_path__ + "static/img/jifenhuodong.194970d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/jifenhuodong.jpg
// module id = lL8J
// module chunks = 25